<template>
  <div class="bg-curious-blue py-[50px] px-[20px] mt-[25px] lg:mt-0">
    <ValidationObserver ref="formObserver">
      <form v-on:submit.prevent="onSubmit">
        <div class="font-primary font-semibold text-[21px] text-white pb-[10px]">{{ trip_booking_title }}</div>
        <div class="font-primary font-light text-[14px] text-white pb-[30px]" v-html="trip_booking_content"></div>
        <div class="flex items-center min-h-[50px] bg-timberwolf bg-opacity-[20%] mb-[5px]">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-white ml-[20px] mr-[5px]" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"/>
          </svg>
          <ValidationProvider rules="name_required" v-slot="{ errors }">
            <input v-model="name" class="font-primary font-light text-[14px] text-white placeholder-white w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none" type="text" v-bind:placeholder="errors.length ? $t(errors[0]) : trip_booking_placeholder_1">
          </ValidationProvider>
        </div>
        <div class="flex items-center min-h-[50px] bg-timberwolf bg-opacity-[20%] mb-[5px]">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-white ml-[20px] mr-[5px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
          </svg>
          <ValidationProvider rules="email_required|email_valid" v-slot="{ errors }" ref="inputEmail">
            <input v-model="email" class="font-primary font-light text-[14px] text-white placeholder-white w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none" type="email" v-bind:placeholder="errors.length ? $t(errors[0]) : trip_booking_placeholder_2">
          </ValidationProvider>
        </div>
        <div class="flex items-center min-h-[50px] bg-timberwolf bg-opacity-[20%] mb-[5px]">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-white ml-[20px] mr-[5px]" viewBox="0 0 20 20" fill="currentColor">
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
          </svg>
          <ValidationProvider rules="phone_required" v-slot="{ errors }">
            <input v-model="phone" class="font-primary font-light text-[14px] text-white placeholder-white w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none" type="text" v-bind:placeholder="errors.length ? $t(errors[0]) : trip_booking_placeholder_3">
          </ValidationProvider>
        </div>
        <div class="flex items-center min-h-[50px] bg-timberwolf bg-opacity-[20%] mb-[5px]">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-white ml-[20px] mr-[5px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
          <v-date-picker v-model="date" v-bind:model-config="modelConfig" mode="date" v-bind:masks="masks">
            <template v-slot="{ inputValue, inputEvents }">
              <input class="font-primary font-light text-[14px] text-white placeholder-white w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none"
                     v-bind:value="inputValue"
                     v-on="inputEvents"/>
            </template>
          </v-date-picker>
        </div>
        <div class="flex items-center min-h-[50px] bg-timberwolf bg-opacity-[20%] mb-[5px]">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-white ml-[20px] mr-[5px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"/>
          </svg>
          <ValidationProvider rules="ticket_required|ticket_valid" v-slot="{ errors }" ref="inputTicket">
            <input v-model="ticket" class="font-primary font-light text-[14px] text-white placeholder-white w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none" type="text" v-bind:placeholder="errors.length ? $t(errors[0]) : trip_booking_placeholder_5">
          </ValidationProvider>
        </div>
        <div class="flex items-start min-h-[50px] bg-timberwolf bg-opacity-[20%] py-[15px] mb-[5px]">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-white ml-[20px] mr-[5px]" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clip-rule="evenodd"/>
          </svg>
          <ValidationProvider rules="message_required" v-slot="{ errors }">
            <textarea v-model="message" class="font-primary font-light text-[14px] text-white placeholder-white w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none" rows="3" v-bind:placeholder="errors.length ? $t(errors[0]) : trip_booking_placeholder_6"></textarea>
          </ValidationProvider>
        </div>
        <a class="w-full inline-flex items-center justify-center self-center font-primary font-light text-[14px] text-white uppercase bg-allports py-[15px] pl-[30px] pr-[25px] border-[1px] border-allports rounded-none mt-[40px] mb-[5px] transition-all ease-in-out duration-300 hover:text-allports hover:bg-white hover:border-allports" v-bind:href="trip_booking_page_1">
          {{ trip_booking_label_1 }}
        </a>
        <button class="w-full inline-flex items-center justify-center self-center font-primary font-light text-[14px] text-white uppercase bg-allports py-[15px] pl-[30px] pr-[25px] border-[1px] border-allports rounded-none mb-[40px] mb-[5px] transition-all ease-in-out duration-300 hover:text-allports hover:bg-white hover:border-allports" type="submit">
          {{ trip_booking_label_2 }}
        </button>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email, numeric } from 'vee-validate/dist/rules';
import axios from 'axios';

extend('name_required', {
  ...required,
  message: 'message.trip_booking_error_1'
});

extend('email_required', {
  ...required,
  message: 'message.trip_booking_error_2'
});

extend('email_valid', {
  ...email,
  message: 'message.trip_booking_error_3'
});

extend('phone_required', {
  ...required,
  message: 'message.trip_booking_error_4'
});

extend('date_required', {
  ...required,
  message: 'message.trip_booking_error_5'
});

extend('date_valid', {
  ...required,
  message: 'message.trip_booking_error_6'
});

extend('ticket_required', {
  ...required,
  message: 'message.trip_booking_error_7'
});

extend('ticket_valid', {
  ...numeric,
  message: 'message.trip_booking_error_8'
});

extend('message_required', {
  ...required,
  message: 'message.trip_booking_error_9'
});

export default {
  name: 'BookingForm',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      wp_ajax: window.trip_post_script_data.wp_ajax,
      wp_nonce: window.trip_post_script_data.wp_nonce,
      trip_booking_title: window.trip_post_script_data.trip_booking_title,
      trip_booking_content: window.trip_post_script_data.trip_booking_content,
      trip_booking_placeholder_1: window.trip_post_script_data.trip_booking_placeholder_1,
      trip_booking_placeholder_2: window.trip_post_script_data.trip_booking_placeholder_2,
      trip_booking_placeholder_3: window.trip_post_script_data.trip_booking_placeholder_3,
      trip_booking_placeholder_4: window.trip_post_script_data.trip_booking_placeholder_4,
      trip_booking_placeholder_5: window.trip_post_script_data.trip_booking_placeholder_5,
      trip_booking_placeholder_6: window.trip_post_script_data.trip_booking_placeholder_6,
      trip_booking_error_1: window.trip_post_script_data.trip_booking_error_1,
      trip_booking_error_2: window.trip_post_script_data.trip_booking_error_2,
      trip_booking_error_3: window.trip_post_script_data.trip_booking_error_3,
      trip_booking_error_4: window.trip_post_script_data.trip_booking_error_4,
      trip_booking_error_5: window.trip_post_script_data.trip_booking_error_5,
      trip_booking_error_6: window.trip_post_script_data.trip_booking_error_6,
      trip_booking_error_7: window.trip_post_script_data.trip_booking_error_7,
      trip_booking_error_8: window.trip_post_script_data.trip_booking_error_8,
      trip_booking_error_9: window.trip_post_script_data.trip_booking_error_9,
      trip_booking_label_1: window.trip_post_script_data.trip_booking_label_1,
      trip_booking_label_2: window.trip_post_script_data.trip_booking_label_2,
      trip_booking_page_1: window.trip_post_script_data.trip_booking_page_1,
      name: '',
      email: '',
      phone: '',
      date: (new Date()).toLocaleDateString('en-GB'),
      modelConfig: {
        type: 'string',
        mask: 'DD-MM-YYYY',
      },
      masks: {
        input: 'DD-MM-YYYY',
      },
      ticket: '',
      message: '',
      trip_title: window.trip_post_script_data.trip_title,
      trip_name: window.trip_post_script_data.trip_name,
    };
  },
  methods: {
    async onSubmit () {
      await this.$recaptchaLoaded();
      this.recaptcha_token = await this.$recaptcha('submit_booking_form');
      this.$refs.formObserver.validate().then(success => {
        if (success) {
          this.loading = true;
          let formData = new FormData();
          formData.append('wp_nonce', this.wp_nonce);
          formData.append('action', 'submit_booking_form');
          formData.append('name', this.name);
          formData.append('email', this.email);
          formData.append('phone', this.phone);
          formData.append('date', this.date);
          formData.append('ticket', this.ticket);
          formData.append('message', this.message);
          formData.append('trip_title', this.trip_title);
          formData.append('trip_name', this.trip_name);
          formData.append('recaptcha_token', this.recaptcha_token);
          axios({
            method: 'POST',
            url: this.wp_ajax,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: formData,
          }).then(response => {
            if (response.data.status === 1) {
              this.$swal('Sent', response.data.message, 'success');
              this.name = this.email = this.phone = this.ticket = this.message = '';
              this.date = (new Date()).toLocaleDateString('en-GB');
              this.$nextTick(() => {
                this.$refs.formObserver.reset();
              });
            } else {
              this.$swal('Error', response.data.message, 'error');
            }
            this.loading = false;
          });
        } else {
          this.$refs.inputEmail.validate().then(result => {
            if (!result.valid) {
              this.email = '';
            }
          });

          this.$refs.inputTicket.validate().then(result => {
            if (!result.valid) {
              this.ticket = '';
            }
          });
        }
      });
      this.loading = false;
    },
  },
};
</script>
<style scoped lang="scss">
</style>
